import React from "react"
import { Box, Typography } from '@mui/material'
import { CircularProgress } from '@mui/joy'

export const ProgressElement = (num, den, message) => (
  <Box sx={{ 
    display: 'flex', 
    flexDirection: 'inline', 
    gap: 1, 
    width: '100%',
    alignItems: 'center',
    background: '#d8e6e5',
    padding: '5px 5px 5px 12px',
    margin: '-5px 0',
    'border-radius': '41px'
  }}>
    <Typography variant="body2" sx={{ textAlign: 'center', color: '#174041' }}>
      {message}
    </Typography>
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
 
        <CircularProgress 
          color="primary"
          size="sm"
          value={((num / den) * 100 * 0.80) + 20}          
          variant="soft"
          thickness={3}
          sx={{
            '--CircularProgress-trackThickness': '3px',
            '--CircularProgress-progressThickness': '3px',
          }}
        />
     
    </Box>
  </Box>
)